import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=02d4a594&scoped=true&"
import script from "./SendMessageModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageModal.vue?vue&type=script&lang=js&"
import style0 from "./SendMessageModal.vue?vue&type=style&index=0&id=02d4a594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d4a594",
  null
  
)

export default component.exports